import * as React from "react";
const SvgIconDropdown = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Ebene_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 36 36", style: {
  enableBackground: "new 0 0 36 36"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "28,0 28,28 0,28 0,36 28,36 36,36 36,28 36,0 " }));
export default SvgIconDropdown;
